module.exports = __webpack_public_path__ + "img/icon-ship.f87064e2.svg";